export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0.5 ,0.5)`)
      .style('font-family', 'roboto')
      .attr('cursor', 'default')

      let grid = this.canvasForms
      .append('g')
      .attr('transform', `translate(380, ${this.chart.y+20})`)

      grid
      .append('text')
      .attr('transform', `translate(0,${9*0.35})`)
      .attr('font-size', 9).attr('fill', '#bcbcbc').attr('text-anchor', 'middle').text('100%')

      grid
      .append('text')
      .attr('transform', `translate(0,${this.chart.height/2 + 9*0.35})`)
      .attr('font-size', 9).attr('fill', '#bcbcbc').attr('text-anchor', 'middle').text('50%')

      grid
      .append('text')
      .attr('transform', `translate(0,${this.chart.height + 9*0.35})`)
      .attr('font-size', 9).attr('fill', '#bcbcbc').attr('text-anchor', 'middle').text('0%')


      let delta = this.canvasForms
      .append('g')
      .attr('transform', `translate(380 ,${this.chart.y+20})`)

      delta
      .append('text')
      .attr('transform', `translate(0,-40)`)
      .attr('font-size', 9).attr('fill', '#333').attr('text-anchor', 'middle').text('Early (Plan)')

      delta
      .append('text')
      .attr('transform', `translate(0,-27)`)
      .attr('font-size', 9).attr('fill', '#333').attr('text-anchor', 'middle').text('Late (Plan)')


      let plan = this.canvasForms
      .append('g')
      .attr('transform', `translate(380 ,${this.chart.y + this.chart.height+20})`)

      plan
      .append('text')
      .attr('transform', `translate(0,29)`)
      .attr('font-size', 9).attr('fill', '#333').attr('text-anchor', 'middle').text('Early (Delta)')

      plan
      .append('text')
      .attr('transform', `translate(0,42)`)
      .attr('font-size', 9).attr('fill', '#333').attr('text-anchor', 'middle').text('Late (Delta)')


      this.schedule.forEach(d=> {
        this.draw_Progress(this.rawData.find(f=> f.SCH == d.code && f.DISC == 'Overall'), d)
        this.draw_Chart(this.rawData.filter(f=> f.SCH == d.code && f.DISC != 'Overall'), d)
      })
      

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },




    
  }
}